import { LOGO_URL } from "@/lib/rooted";

/**
 * Photorealistic iPhone frame. Renders one of: `video`, `image`, or `children`.
 * `size` — sm | md
 * `tilt` — degrees to rotate the frame (subtle showcase tilt on the Learn More page)
 */
export const PhoneMockup = ({
  image,
  video,
  poster,
  children,
  size = "md",
  tilt = 0,
  testId = "phone-mockup",
}) => {
  const widths = {
    sm: "w-[200px] sm:w-[220px] md:w-[240px]",
    md: "w-[300px] sm:w-[320px] md:w-[340px]",
  }[size] || "w-[300px] sm:w-[320px] md:w-[340px]";

  const style = tilt ? { transform: `rotate(${tilt}deg)` } : undefined;

  return (
    <div
      data-testid={testId}
      style={style}
      className={`phone-frame relative mx-auto ${widths} aspect-[9/19.2] rounded-[3rem] p-[7px] bg-gradient-to-b from-[#1a1a1a] via-[#0a0a0a] to-[#0e0e0e] border border-[#1f1f1f] transition-transform duration-500`}
    >
      <span className="absolute left-[-2px] top-[110px] w-[2px] h-10 rounded-r bg-[#1c1c1c]" />
      <span className="absolute left-[-2px] top-[160px] w-[2px] h-16 rounded-r bg-[#1c1c1c]" />
      <span className="absolute right-[-2px] top-[140px] w-[2px] h-20 rounded-l bg-[#1c1c1c]" />

      <div className="relative w-full h-full rounded-[2.55rem] overflow-hidden bg-black">
        {video ? (
          <video
            src={video}
            poster={poster}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="absolute inset-0 w-full h-full object-cover"
            draggable={false}
          />
        ) : image ? (
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-contain object-center"
            draggable={false}
          />
        ) : (
          <>
            <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 w-[88px] h-[26px] rounded-full bg-black/95" />
            {children}
          </>
        )}
      </div>
    </div>
  );
};

// Keep a small logo import reference so bundlers don't tree-shake it in some rare edge.
export const _logoRef = LOGO_URL;

export default PhoneMockup;
